// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-section {
  width: 100%;
  background-color: #F5F5F5;
  position: relative;
  overflow: hidden;
  z-index: 2;
  padding: 400px 0 240px 0;
  border-radius: 64px 64px 0px 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 550px) {
  .form-section {
    border-radius: 24px 24px 0px 0px;
  }
}
@media (max-width: 1050px) {
  .form-section {
    padding: 350px 0 170px 0;
  }
}
@media (max-width: 1050px) {
  .form-section {
    padding: 250px 0 170px 0;
  }
}
.form-section .form-section-lottie-container {
  width: 1000px;
  height: 500px;
  scale: 5;
  position: absolute;
  bottom: 240px;
}
@media (min-width: 1620px) {
  .form-section .form-section-lottie-container {
    scale: 7;
  }
}
@media (max-width: 1400px) {
  .form-section .form-section-lottie-container {
    scale: 3.5;
  }
}
@media (max-width: 800px) {
  .form-section .form-section-lottie-container {
    bottom: 440px;
    scale: 2.5;
  }
}
@media (max-width: 700px) {
  .form-section .form-section-lottie-container {
    width: 800px;
    height: 400px;
    bottom: 480px;
  }
}
@media (max-width: 550px) {
  .form-section .form-section-lottie-container {
    bottom: 420px;
  }
}
.form-section .form-section-lottie-container.right {
  right: -30%;
  transform: scaleX(-1);
}
@media (max-width: 1400px) {
  .form-section .form-section-lottie-container.right {
    right: -40%;
  }
}
@media (max-width: 1050px) {
  .form-section .form-section-lottie-container.right {
    right: -55%;
  }
}
@media (max-width: 900px) {
  .form-section .form-section-lottie-container.right {
    right: -60%;
  }
}
@media (max-width: 800px) {
  .form-section .form-section-lottie-container.right {
    right: -70%;
  }
}
@media (max-width: 700px) {
  .form-section .form-section-lottie-container.right {
    right: -65%;
  }
}
@media (max-width: 550px) {
  .form-section .form-section-lottie-container.right {
    right: -85%;
  }
}
@media (max-width: 450px) {
  .form-section .form-section-lottie-container.right {
    right: -100%;
  }
}
@media (max-width: 400px) {
  .form-section .form-section-lottie-container.right {
    right: -110%;
  }
}
.form-section .form-section-lottie-container.left {
  left: -30%;
}
@media (max-width: 1400px) {
  .form-section .form-section-lottie-container.left {
    left: -40%;
  }
}
@media (max-width: 1050px) {
  .form-section .form-section-lottie-container.left {
    left: -55%;
  }
}
@media (max-width: 900px) {
  .form-section .form-section-lottie-container.left {
    left: -60%;
  }
}
@media (max-width: 800px) {
  .form-section .form-section-lottie-container.left {
    left: -70%;
  }
}
@media (max-width: 700px) {
  .form-section .form-section-lottie-container.left {
    left: -65%;
  }
}
@media (max-width: 550px) {
  .form-section .form-section-lottie-container.left {
    left: -85%;
  }
}
@media (max-width: 450px) {
  .form-section .form-section-lottie-container.left {
    left: -100%;
  }
}
@media (max-width: 400px) {
  .form-section .form-section-lottie-container.left {
    left: -110%;
  }
}
.form-section .form-section-container {
  width: calc(100% - 160px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
@media (min-width: 1620px) {
  .form-section .form-section-container {
    width: calc(100% - 200px);
  }
}
@media (max-width: 1050px) {
  .form-section .form-section-container {
    width: calc(100% - 80px);
  }
}
@media (max-width: 550px) {
  .form-section .form-section-container {
    width: calc(100% - 32px);
  }
}
.form-section .form-section-container .form-section-title-mobile {
  display: none;
}
@media (max-width: 800px) {
  .form-section .form-section-container .form-section-title-mobile {
    width: 100%;
    display: block;
    margin-bottom: 96px;
    color: #575756;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-section .form-section-container .form-section-title-mobile .form-section-title-main-text {
    letter-spacing: -1.38px;
    text-transform: uppercase;
    overflow: hidden;
    white-space: nowrap;
    align-self: center;
    font-family: FixelDisplay;
    font-size: 54px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 800px) and (max-width: 550px) {
  .form-section .form-section-container .form-section-title-mobile .form-section-title-main-text {
    font-family: FixelDisplay;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 800px) {
  .form-section .form-section-container .form-section-title-mobile .form-section-title-main-text .char {
    opacity: 0;
    display: inline-block;
  }
}
.form-section .form-section-container .form-section-title {
  width: 100%;
  position: relative;
  margin-bottom: 244px;
  color: #575756;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
@media (max-width: 1050px) {
  .form-section .form-section-container .form-section-title {
    margin-bottom: 104px;
  }
}
@media (max-width: 800px) {
  .form-section .form-section-container .form-section-title {
    display: none;
  }
}
.form-section .form-section-container .form-section-title .form-section-title-main-text {
  letter-spacing: -4.96px;
  text-transform: uppercase;
  overflow: hidden;
  white-space: nowrap;
  font-family: FixelDisplay;
  font-size: 124px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
}
@media (min-width: 1620px) {
  .form-section .form-section-container .form-section-title .form-section-title-main-text {
    letter-spacing: -6.4px;
    font-family: FixelDisplay;
    font-size: 140px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 1400px) {
  .form-section .form-section-container .form-section-title .form-section-title-main-text {
    letter-spacing: -6.4px;
    font-family: FixelDisplay;
    font-size: 90px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 1050px) {
  .form-section .form-section-container .form-section-title .form-section-title-main-text {
    letter-spacing: -1.92px;
    font-family: FixelDisplay;
    font-size: 64px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
.form-section .form-section-container .form-section-title .form-section-title-main-text .char {
  opacity: 0;
  display: inline-block;
}
.form-section .form-section-container .form-section-title .form-section-title-main-text.first {
  align-self: center;
}
.form-section .form-section-container .form-section-title .form-section-title-main-text.third {
  align-self: flex-end;
}
.form-section .form-section-container .form-section-title .form-section-title-small-text {
  width: 150px;
  position: absolute;
  right: 7%;
  top: 50%;
  transform: translateY(-50%);
  letter-spacing: 0.14px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .form-section .form-section-container .form-section-title .form-section-title-small-text {
    right: unset;
    left: 1200px;
  }
}
@media (max-width: 1050px) {
  .form-section .form-section-container .form-section-title .form-section-title-small-text {
    width: 188px;
    right: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FormSection/FormSection.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,yBCDe;EDEf,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,wBAAA;EACA,gCAAA;EETA,aAAA;EACA,mBFSqB;EERrB,uBFQ0B;EEP1B,mBFOkC;AACtC;AACI;EAVJ;IAWQ,gCAAA;EAEN;AACF;AAAI;EAdJ;IAeQ,wBAAA;EAGN;AACF;AADI;EAlBJ;IAmBQ,wBAAA;EAIN;AACF;AAFI;EACI,aAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;AAIR;AAFQ;EAPJ;IAQQ,QAAA;EAKV;AACF;AAHQ;EAXJ;IAYQ,UAAA;EAMV;AACF;AAJQ;EAfJ;IAgBQ,aAAA;IACA,UAAA;EAOV;AACF;AALQ;EApBJ;IAqBQ,YAAA;IACA,aAAA;IACA,aAAA;EAQV;AACF;AANQ;EA1BJ;IA2BQ,aAAA;EASV;AACF;AAPQ;EACI,WAAA;EACA,qBAAA;AASZ;AAPY;EAJJ;IAKQ,WAAA;EAUd;AACF;AARY;EARJ;IASQ,WAAA;EAWd;AACF;AATY;EAZJ;IAaQ,WAAA;EAYd;AACF;AAVY;EAhBJ;IAiBQ,WAAA;EAad;AACF;AAXY;EApBJ;IAqBQ,WAAA;EAcd;AACF;AAZY;EAxBJ;IAyBQ,WAAA;EAed;AACF;AAbY;EA5BJ;IA6BQ,YAAA;EAgBd;AACF;AAdY;EAhCJ;IAiCQ,YAAA;EAiBd;AACF;AAdQ;EACI,UAAA;AAgBZ;AAdY;EAHJ;IAIQ,UAAA;EAiBd;AACF;AAfY;EAPJ;IAQQ,UAAA;EAkBd;AACF;AAhBY;EAXJ;IAYQ,UAAA;EAmBd;AACF;AAjBY;EAfJ;IAgBQ,UAAA;EAoBd;AACF;AAlBY;EAnBJ;IAoBQ,UAAA;EAqBd;AACF;AAnBY;EAvBJ;IAwBQ,UAAA;EAsBd;AACF;AApBY;EA3BJ;IA4BQ,WAAA;EAuBd;AACF;AArBY;EA/BJ;IAgCQ,WAAA;EAwBd;AACF;AApBI;EACI,yBAAA;EACA,YAAA;EElIJ,aAAA;EACA,sBFkIyB;EEjIzB,2BFiIiC;EEhIjC,mBFgI6C;AAyBjD;AAvBQ;EALJ;IAMQ,yBAAA;EA0BV;AACF;AAxBQ;EATJ;IAUQ,wBAAA;EA2BV;AACF;AAzBQ;EAbJ;IAcQ,wBAAA;EA4BV;AACF;AA1BQ;EACI,aAAA;AA4BZ;AA1BY;EAHJ;IAIQ,WAAA;IACA,cAAA;IACA,mBAAA;IACA,cCjJJ;ICPR,aAAA;IACA,sBFwJiC;IEvJjC,2BFuJyC;IEtJzC,uBFsJqD;EAgCvD;EA9Bc;IACI,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,mBAAA;IACA,kBAAA;IEzJhB,yBF0JqC;IEzJrC,eFyJmD;IExJnD,kBFwJyD;IEvJzD,gBFuJiE;IEtJjE,gBFsJsE;EAoCxE;AACF;AAnCoB;EARJ;IEpJZ,yBF6JyC;IE5JzC,eF4JuD;IE3JvD,kBF2J6D;IE1J7D,gBF0JqE;IEzJrE,gBFyJ0E;EA0C5E;AACF;AA3DY;EAmBQ;IACI,UAAA;IACA,qBAAA;EA2CtB;AACF;AAtCQ;EACI,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,cC5KA;ECPR,aAAA;EACA,sBFmL6B;EElL7B,2BFkLqC;EEjLrC,uBFiLiD;AA2CrD;AAzCY;EAPJ;IAQQ,oBAAA;EA4Cd;AACF;AA1CY;EAXJ;IAYQ,aAAA;EA6Cd;AACF;AA3CY;EACI,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EE3LZ,yBF4LiC;EE3LjC,gBF2L+C;EE1L/C,kBF0LsD;EEzLtD,gBFyL8D;EExL9D,gBFwLmE;AAiDvE;AA9CgB;EARJ;IASQ,sBAAA;IEhMhB,yBFiMqC;IEhMrC,gBFgMmD;IE/LnD,kBF+L0D;IE9L1D,gBF8LkE;IE7LlE,gBF6LuE;EAqDzE;AACF;AAnDgB;EAbJ;IAcQ,sBAAA;IErMhB,yBFsMqC;IErMrC,eFqMmD;IEpMnD,kBFoMyD;IEnMzD,gBFmMiE;IElMjE,gBFkMsE;EA0DxE;AACF;AAxDgB;EAlBJ;IAmBQ,uBAAA;IE1MhB,yBF2MqC;IE1MrC,eF0MmD;IEzMnD,kBFyMyD;IExMzD,gBFwMiE;IEvMjE,gBFuMsE;EA+DxE;AACF;AA7DgB;EACI,UAAA;EACA,qBAAA;AA+DpB;AA5DgB;EACI,kBAAA;AA8DpB;AA3DgB;EACI,oBAAA;AA6DpB;AAzDY;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EEnOZ,yBFoOiC;EEnOjC,eFmO+C;EElO/C,kBFkOqD;EEjOrD,gBFiO6D;EEhO7D,iBFgOkE;AA+DtE;AA7DgB;EAVJ;IAWQ,YAAA;IACA,YAAA;EAgElB;AACF;AA9DgB;EAfJ;IAgBQ,YAAA;IACA,WAAA;EAiElB;AACF","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.form-section {\n    width: 100%;\n    background-color: $light-background;\n    position: relative;\n    overflow: hidden;\n    z-index: 2;\n    padding: 400px 0 240px 0;\n    border-radius: 64px 64px 0px 0px;\n    @include mixins.flex(row, center, center);\n\n    @media (max-width: 550px) {\n        border-radius: 24px 24px 0px 0px;\n    }\n\n    @media (max-width: 1050px) {\n        padding: 350px 0 170px 0;\n    }\n\n    @media (max-width: 1050px) {\n        padding: 250px 0 170px 0;\n    }\n\n    .form-section-lottie-container {\n        width: 1000px;\n        height: 500px;\n        scale: 5;\n        position: absolute;\n        bottom: 240px;\n\n        @media (min-width: 1620px) {\n            scale: 7;\n        }\n\n        @media (max-width: 1400px) {\n            scale: 3.5;\n        }\n\n        @media (max-width: 800px) {\n            bottom: 440px;\n            scale: 2.5;\n        }\n\n        @media (max-width: 700px) {\n            width: 800px;\n            height: 400px;\n            bottom: 480px;\n        }\n\n        @media (max-width: 550px) {\n            bottom: 420px;\n        }\n\n        &.right {\n            right: -30%;\n            transform: scaleX(-1);\n\n            @media (max-width: 1400px) {\n                right: -40%;\n            }\n\n            @media (max-width: 1050px) {\n                right: -55%;\n            }\n\n            @media (max-width: 900px) {\n                right: -60%;\n            }\n\n            @media (max-width: 800px) {\n                right: -70%;\n            }\n\n            @media (max-width: 700px) {\n                right: -65%;\n            }\n\n            @media (max-width: 550px) {\n                right: -85%;\n            }\n\n            @media (max-width: 450px) {\n                right: -100%;\n            }\n\n            @media (max-width: 400px) {\n                right: -110%;\n            }\n        }\n\n        &.left {\n            left: -30%;\n\n            @media (max-width: 1400px) {\n                left: -40%;\n            }\n\n            @media (max-width: 1050px) {\n                left: -55%;\n            }\n\n            @media (max-width: 900px) {\n                left: -60%;\n            }\n\n            @media (max-width: 800px) {\n                left: -70%;\n            }\n\n            @media (max-width: 700px) {\n                left: -65%;\n            }\n\n            @media (max-width: 550px) {\n                left: -85%;\n            }\n\n            @media (max-width: 450px) {\n                left: -100%;\n            }\n\n            @media (max-width: 400px) {\n                left: -110%;\n            }\n        }\n    }\n\n    .form-section-container {\n        width: calc(100% - 160px);\n        height: 100%;\n        @include mixins.flex(column, flex-start, center);\n\n        @media (min-width: 1620px) {\n            width: calc(100% - 200px);\n        }\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 80px);\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 32px);\n        }\n\n        .form-section-title-mobile {\n            display: none;\n\n            @media (max-width: 800px) {\n                width: 100%;\n                display: block;\n                margin-bottom: 96px;\n                color: $grey-dark;\n                @include mixins.flex(column, flex-start, flex-start);\n\n                .form-section-title-main-text {\n                    letter-spacing: -1.38px;\n                    text-transform: uppercase;\n                    overflow: hidden;\n                    white-space: nowrap;\n                    align-self: center;\n                    @include mixins.font(FixelDisplay, 54px, normal, 400, 90%);\n\n                    @media (max-width: 550px) {\n                        @include mixins.font(FixelDisplay, 46px, normal, 400, 90%);\n                    }\n\n                    .char {\n                        opacity: 0;\n                        display: inline-block;\n                    }\n                }\n            }\n        }\n\n        .form-section-title {\n            width: 100%;\n            position: relative;\n            margin-bottom: 244px;\n            color: $grey-dark;\n            @include mixins.flex(column, flex-start, flex-start);\n\n            @media (max-width: 1050px) {\n                margin-bottom: 104px;\n            }\n\n            @media (max-width: 800px) {\n                display: none;\n            }\n\n            .form-section-title-main-text {\n                letter-spacing: -4.96px;\n                text-transform: uppercase;\n                overflow: hidden;\n                white-space: nowrap;\n                @include mixins.font(FixelDisplay, 124px, normal, 400, 90%);\n\n\n                @media (min-width: 1620px) {\n                    letter-spacing: -6.4px;\n                    @include mixins.font(FixelDisplay, 140px, normal, 400, 90%);\n                }\n\n                @media (max-width: 1400px) {\n                    letter-spacing: -6.4px;\n                    @include mixins.font(FixelDisplay, 90px, normal, 400, 90%);\n                }\n\n                @media (max-width: 1050px) {\n                    letter-spacing: -1.92px;\n                    @include mixins.font(FixelDisplay, 64px, normal, 400, 90%);\n                }\n\n                .char {\n                    opacity: 0;\n                    display: inline-block;\n                }\n\n                &.first {\n                    align-self: center;\n                }\n\n                &.third {\n                    align-self: flex-end;\n                }\n            }\n\n            .form-section-title-small-text {\n                width: 150px;\n                position: absolute;\n                right: 7%;\n                top: 50%;\n                transform: translateY(-50%);\n                letter-spacing: 0.14px;\n                text-transform: uppercase;\n                @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                @media (min-width: 1620px) {\n                    right: unset;\n                    left: 1200px;\n                }\n\n                @media (max-width: 1050px) {\n                    width: 188px;\n                    right: 30px;\n                }\n            }\n        }\n    }\n\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
